export class KafkaSampleProbeRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "bootstrapServers",
            "baseName": "bootstrapServers",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "security",
            "baseName": "security",
            "type": "KafkaSecurityConfig",
            "format": ""
        },
        {
            "name": "topic",
            "baseName": "topic",
            "type": "string",
            "format": ""
        },
        {
            "name": "partitions",
            "baseName": "partitions",
            "type": "Array<number>",
            "format": ""
        },
        {
            "name": "offsetStrategy",
            "baseName": "offsetStrategy",
            "type": "KafkaOffsetStrategy",
            "format": ""
        },
        {
            "name": "fromOffset",
            "baseName": "fromOffset",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "count",
            "baseName": "count",
            "type": "number",
            "format": ""
        },
        {
            "name": "maxBytesPerMsg",
            "baseName": "maxBytesPerMsg",
            "type": "number",
            "format": ""
        },
        {
            "name": "formatHint",
            "baseName": "formatHint",
            "type": "KafkaMessageFormat",
            "format": ""
        },
        {
            "name": "keyFormatHint",
            "baseName": "keyFormatHint",
            "type": "KafkaMessageFormat",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaSampleProbeRequest.attributeTypeMap;
    }
    constructor() {
    }
}
